// 管理系统: 左侧菜单
export const menus = [{
		id: 1,
		path: '/userManage',
		name: 'UserManage',
		component: () => import('@/views/manage/pages/user/userManage.vue'),
		title: '用户管理',
		icon: 'el-icon-user-solid',
		show: true,
	},
	{
		id: 2,
		path: '/emailManage',
		name: 'EmailManage',
		component: () => import('@/views/manage/pages/email/emailManage.vue'),
		title: '邮箱后缀管理',
		icon: 'el-icon-platform-eleme',
		show: true,
	}
]


// 用户状态
export const userStatusArr = [{
		value: 0,
		label: '等待邮箱验证'
	},
	{
		value: 1,
		label: '等待审核'
	},
	{
		value: 10,
		label: '正常'
	}
]